export enum AdminType {
  admin = 'admin',
  patientManager = 'patientManager',
  none = 'none',
}
